import React from 'react'
import { ReactComponent as ErrorIcon } from '../../../../assets/svg/icons/error-icon.svg'

const ErrorRow = ({ children }) => {    
    return (
        <div className="error-row">
            <span className="text">{children}</span>
            <ErrorIcon className="icon" />
        </div>
    )
}

export default ErrorRow
